import { useView } from '../../hooks';
import { useWebhooks } from './useWebhooks';
import { formatDate } from '../../utilities';
import { booleanize } from '../../utilities';
import { useAppContext } from '../../shared';
import { Dropdown, Input, Table } from '../../components';
import { Form, FormItem, TopPanel } from '../../components';
import { Slug, Button, PaginatePanel } from '../../components';

const getColor = (event_type: string): SlugColorType => {
  switch (event_type) {
    case 'workflow_completed':
      return 'success';
    case 'phone_call_ended':
      return 'danger';
    default:
      return 'main';
  }
};

const Webhooks = () => {
  const { meta } = useAppContext();
  const { element, handleView } = useView();
  const {
    nodes,
    refresh,
    filters,
    setFilters,
    initializing: loading,
    reloading,
    sort,
    setSort,
    setPage,
    pagination,
  } = useWebhooks();

  return (
    <div className="flex flex-col gap-y-md w-full">
      {element}
      <TopPanel>
        <Form<NonNullable<typeof filters>>
          initialValue={filters}
          onChange={setFilters}
        >
          <FormItem<NonNullable<typeof filters>> name="contactId" label="">
            <Input placeholder="Filter By Contact Email" />
          </FormItem>
          <FormItem<NonNullable<typeof filters>> name="campaignId" label="">
            <Dropdown
              placeholder="Campaign"
              grow={false}
              options={[
                { value: '', label: 'All Campaigns' },
                ...meta.campaigns,
              ]}
            />
          </FormItem>
          <FormItem<NonNullable<typeof filters>> name="eventType" label="">
            <Dropdown
              placeholder="Type"
              grow={false}
              options={[
                { value: '', label: 'All Types' },
                { value: 'email_received', label: 'Email Received' },
                { value: 'sms_received', label: 'SMS Received' },
                { value: 'phone_call_started', label: 'Phone Call Started' },
                { value: 'phone_call_ended', label: 'Phone Call Ended' },
                { value: 'workflow_completed', label: 'Workflow Completed' },
              ]}
            />
          </FormItem>
        </Form>
        <Button icon="refresh" loading={reloading} onClick={refresh}>
          Refresh
        </Button>
      </TopPanel>
      <PaginatePanel {...pagination} setPage={setPage} />
      <div className="flex-1 overflow-y-auto">
        <Table
          data={nodes}
          loading={loading}
          sort={sort}
          onSort={setSort}
          config={{
            columns: [
              {
                header: 'Type',
                sortName: 'event_type',
                cellClassName: 'max-w-[14rem]',
                getValue: ({ event_type, event_type_enum }) => (
                  <Slug text={event_type} color={getColor(event_type_enum)} />
                ),
              },
              {
                header: 'Contact',
                sortName: 'contact_id',
                cellClassName: 'text-tiny max-w-[16rem]',
                getValue: ({ contact_id }) => contact_id,
                // getValue: ({ contact_id }) => contact_id.split('@')[0] || '-',
              },
              {
                header: 'Processed',
                sortName: 'processed',
                cellClassName: 'max-w-[10rem]',
                getValue: ({ processed }) => (
                  <Slug
                    className="max-w-[5rem]"
                    text={String(processed)}
                    color={booleanize(processed) ? 'success' : 'warning'}
                  />
                ),
              },
              {
                header: 'Created',
                sortName: 'created_at',
                cellClassName: 'text-tiny max-w-[11.5rem]',
                cellContentClassName: 'max-w-[16.5rem]',
                getValue: ({ created_at }) => formatDate(created_at),
              },
              {
                header: 'Payload',
                align: 'right',
                getValue: ({ payload }) => (
                  <Button icon="eye" onClick={() => handleView(payload)}>
                    View
                  </Button>
                ),
              },
            ],
          }}
        />
      </div>
    </div>
  );
};

export default Webhooks;
